<div class="container">
  <div class="header">
    <div [fiTranslation]="additionalContact ? 'REQUEST_DETAIL_CONTACT_ADD_COMPANY_CONTACT' : 'REQUEST_EDIT_CONTACT_TITLE'"></div>
    <fi-button
      variant="tertiary"
      tone="neutral"
      size="lg"
      [iconOnly]="true"
      (click)="onClosePopup()"
    >
      <mat-icon fiButtonIcon>close</mat-icon>
      <span fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
    </fi-button>
  </div>

  <div class="form-container"
    [class.private]="contactForm?.controls.ContactTypeId.value === ContactHelper.CONTACT_TYPE_PRIVATE"
    [class.trade]="contactForm?.controls.ContactTypeId.value === ContactHelper.CONTACT_TYPE_TRADE"
    [class.planer]="contactForm?.controls.ContactTypeId.value === ContactHelper.CONTACT_TYPE_PLANER"
    >
    @if (loadedContact) {
      <fi-contact-form
        [privacy]="{ contact: true, documented: true }"
        [contactForm]="contactForm"
        [requestForm]="requestForm"
        [isNewLeadForm]= "false"
        [showPrivate] = "additionalContact ? false : true"
        [isUpdate]="true"
        [compendiumActionEnabled]="compendiumActionEnabled"
        [compendiumVisible]="compendiumVisible"
        [additionalContact]="additionalContact"
        >
      </fi-contact-form>
    }
  </div>



  <div class="footer">
    <button (click)="onSubmit()" [class.padding]="additionalContact">
      @if (additionalContact) {
        <img src="assets/icons/user.svg" alt="contact">
      }
      <span [fiTranslation]="additionalContact ? 'REQUEST_DETAIL_CONTACT_ADD_COMPANY_CONTACT' : 'ALT_TEXT_SAVE_PROFILE'"></span>
    </button>
  </div>
</div>
